import React, { useMemo } from "react";
import ProgressBar from "./ProgressBar";

const clamp = (v, a, b) => Math.max(a, Math.min(b, v));

/**
 * Convertit n'importe quel format vers une note /10 :
 * - 0..1 -> *10
 * - 0..10 -> inchangé
 * - 0..100 -> /10
 * - 0..10000 (ex: 6500) -> /1000
 */
const toScore10 = (v) => {
  const n = Number(v);
  if (!Number.isFinite(n)) return 0;

  // ancien format 0-1
  if (n >= 0 && n <= 1.5) return clamp(n * 10, 0, 10);

  // format percent (0-100)
  if (n > 10 && n <= 100) return clamp(n / 10, 0, 10);

  // cas bug type 6500 (= 65 * 100)
  if (n > 100 && n <= 10000) return clamp(n / 1000, 0, 10);

  // déjà /10
  return clamp(n, 0, 10);
};

const score10ToPct = (score10) => clamp((Number(score10) / 10) * 100, 0, 100);

const getColorByScore10 = (score10) => {
  // règles: <4 pas bon, 4-6 moyen, >6 bien
  if (score10 < 4) return "rose";
  if (score10 < 6) return "amber";
  return "emerald";
};

const MuscleTrainabilityBar = ({ muscle, right, left, isDarkMode, maxValue = 10 }) => {
  // maxValue laissé au cas où tu veux autre chose plus tard
  // mais on travaille en /10
  const right10 = useMemo(() => toScore10(right), [right]);
  const left10 = useMemo(() => toScore10(left), [left]);

  const avg10 = useMemo(() => (right10 + left10) / 2, [right10, left10]);

  const rightPct = score10ToPct(right10);
  const leftPct = score10ToPct(left10);

  const color = getColorByScore10(avg10);

  return (
    <div className="space-y-1">
      <div className="flex items-center justify-between text-xs">
        <span className={isDarkMode ? "text-gray-300" : "text-gray-600"}>{muscle}</span>
        <span className="font-medium">{avg10.toFixed(1)}/10</span>
      </div>

      <div className="flex gap-1">
        <div className="flex-1">
          <div className="text-[10px] text-gray-400 mb-0.5">D</div>
          <ProgressBar value={rightPct} color={color} height="h-1.5" />
        </div>

        <div className="flex-1">
          <div className="text-[10px] text-gray-400 mb-0.5">G</div>
          <ProgressBar value={leftPct} color={color} height="h-1.5" />
        </div>
      </div>
    </div>
  );
};

export default MuscleTrainabilityBar;
